import * as React from 'react'

export const SVG_Exit = (props: { color?: string; width?: number; height?: number }) => (
    <svg
        width={props.width || '32'}
        height={props.height || '33'}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18.0751 4.70985C18.4106 4.37433 18.9546 4.37433 19.2901 4.70985C19.6257 5.04537 19.6257 5.58936 19.2901 5.92488L5.92488 19.2901C5.58936 19.6257 5.04537 19.6257 4.70985 19.2901C4.37433 18.9546 4.37433 18.4106 4.70985 18.0751L18.0751 4.70985Z"
            fill={props.color || '#4f5b68'}
        />
        <path
            d="M4.70985 5.92488C4.37433 5.58936 4.37433 5.04537 4.70985 4.70985C5.04537 4.37433 5.58936 4.37433 5.92488 4.70985L19.2901 18.0751C19.6257 18.4106 19.6257 18.9546 19.2901 19.2901C18.9546 19.6257 18.4106 19.6257 18.0751 19.2901L4.70985 5.92488Z"
            fill={props.color || '#4f5b68'}
        />
        <path
            d="M18.0751 4.70985C18.4106 4.37433 18.9546 4.37433 19.2901 4.70985C19.6257 5.04537 19.6257 5.58936 19.2901 5.92488L13.215 12L19.2901 18.0751C19.6257 18.4106 19.6257 18.9546 19.2901 19.2901C18.9546 19.6257 18.4106 19.6257 18.0751 19.2901L12 13.215L5.92488 19.2901C5.58936 19.6257 5.04537 19.6257 4.70985 19.2901C4.37433 18.9546 4.37433 18.4106 4.70985 18.0751L10.785 12L4.70985 5.92488C4.37433 5.58936 4.37433 5.04537 4.70985 4.70985C5.04537 4.37433 5.58936 4.37433 5.92488 4.70985L12 10.785L18.0751 4.70985ZM12 10.137L17.7511 4.38585C18.2656 3.87138 19.0997 3.87138 19.6142 4.38585C20.1286 4.90031 20.1286 5.73442 19.6142 6.24888L13.863 12L19.6142 17.7511C20.1286 18.2656 20.1286 19.0997 19.6142 19.6142C19.0997 20.1286 18.2656 20.1286 17.7511 19.6142L12 13.863L6.24888 19.6142C5.73442 20.1286 4.90031 20.1286 4.38585 19.6142C3.87138 19.0997 3.87138 18.2656 4.38585 17.7511L10.137 12L4.38585 6.24888C3.87138 5.73442 3.87138 4.90031 4.38585 4.38585C4.90031 3.87138 5.73442 3.87138 6.24888 4.38585L12 10.137Z"
            fill={props.color || '#4f5b68'}
        />
    </svg>
)
